import { Button, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { getSalusUserDetail } from '../../api/electronicApproval.api'
import {
  isAopsChiefState,
  menuSelectedStudio,
  menuSelectedTeam,
} from '../../store/aops'
import { userAuthStatus, userState } from '../../store/user'
import './aopsCommonHeader.scss'

const { Text, Title } = Typography
const AopsHeader = ({ active }) => {
  const { team } = useParams()
  const navigate = useNavigate()
  const routeName = useLocation().pathname
  const isElectricApproval = routeName.includes('/electric-approval')
  const [selectedStudio, setSelectedStudio] = useRecoilState(menuSelectedStudio)
  const [selectedTeam, setSelectedTeam] = useRecoilState(menuSelectedTeam)
  const [user] = useRecoilState(userState)
  const [salusUserDetail, setSalusUserDetail] = useState(null)
  const [isAopsChief, setIsAopsChief] = useRecoilState(isAopsChiefState)
  const [userAuth] = useRecoilState(userAuthStatus)
  // const [my]
  useEffect(() => {
    const fetchSalusUserDetail = async () => {
      const res = await getSalusUserDetail({ salusUserId: user?.id })
      setSalusUserDetail(res)
      // console.log('salusUserDetail', salusUserDetail)
      setIsAopsChief(res?.position?.toLowerCase() === 'chief')
    }
    if (user?.id) fetchSalusUserDetail()
  }, [user])

  useEffect(() => {
    const parts = routeName.split('/').filter(Boolean)
    // /standalone-admin-schedule/:studio → parts[1]=studio
    // /standalone-admin-schedule/:studio/:team → parts[1]=studio, parts[2]=team
    // /standalone-schedule/:studio/:team/:id → parts[1]=studio, parts[2]=team
    // /schedule/:team → parts[1]=schedule, parts[2]=team
    if (routeName.includes('standalone-admin-schedule')) {
      setSelectedStudio(parts[1] ?? null)
      setSelectedTeam(parts[2] ?? null)
    } else if (routeName.includes('standalone-schedule')) {
      setSelectedStudio(parts[1] ?? null)
      setSelectedTeam(parts[2] ?? null)
    } else if (routeName.includes('/schedule/')) {
      // /schedule/:team → parts[0]=schedule, parts[1]=team
      setSelectedStudio(null)
      setSelectedTeam(parts[1] ?? null)
    } else {
      const teamName = parts[1] ?? null
      if (teamName) setSelectedTeam(teamName)
    }
  }, [routeName])

  return (
    <div style={{ marginBottom: '20px' }}>
      <div className={`header-box`} style={{ position: 'relative' }}>
        {/* <p className={`header-title`}>
          {!isElectricApproval ? '칸반보드 /  스크럼' : '기안서 결제 대시보드'}
        </p> */}

        <div style={{ display: 'flex', gap: 20 }}>
          <Button
            type="default"
            className={`menu-button ${
              active === 'schedule' ? 'active-button' : 'inactive-button'
            }`}
            onClick={() =>
              navigate(`/schedule/${selectedTeam ?? userAuth?.teamName ?? ''}`)
            }
          >
            애자일 / 스크럼보드
          </Button>
          {/* <Button
            type="default"
            className={`menu-button ${
              active === 'electric-approval'
                ? 'active-button'
                : 'inactive-button'
            }`}
            // style={{ color: '#555' }}
            onClick={() => navigate(`/electric-approval/${selectedTeam}`)}
          >
            Ops. / 스케줄보드
          </Button> */}
          {(userAuth.teamName === selectedTeam ||
            userAuth.studioName === selectedStudio) && (
            <Button
              type="default"
              className={`menu-button ${
                active === 'schedule-dashboard'
                  ? 'active-button'
                  : 'inactive-button'
              }`}
              onClick={() =>
                navigate(
                  `/standalone-admin-schedule/${userAuth.studioName}/${userAuth.teamName}`,
                )
              }
            >
              Ops. / 스케줄보드
            </Button>
          )}
        </div>
        {/* {salusUserDetail?.position?.toLowerCase() === 'chief' && (
          <div
            style={{
              display: 'flex',
              gap: 10,
              position: 'absolute',
              right: 30,
              bottom: 18,
            }}
          >
            <Button
              type="default"
              onClick={() => navigate(`/add-aops-member`)}
              style={{
                background: '#fff',
              }}
            >
              ✨ AOPS로 초대하기
            </Button>
            <div type="default" disabled={true} className="admin-mode-chip">
              관리자 Mode
            </div>
          </div>
        )} */}
      </div>
    </div>
  )
}

export default AopsHeader
